import { calculate } from '@playbooks/core/src/utils/formula'
import { BaseNumberQuestionNode } from './BaseNumberQuestionNode'
import { QuestionNode } from './QuestionNode'
import { QuestionData } from '../../../types'

/**
 * FormulaQuestionNode Class
 *
 * Represents a read-only question node that derives its value from a mathematical
 * expression. It dynamically calculates results based on other Number nodes in the tree.
 */
export class FormulaQuestionNode extends QuestionNode {
  declare data: QuestionData<number>

  public override setValue(): void {
    throw new Error('Not supported')
  }

  public override setStringValue(): void {
    throw new Error('Not supported')
  }

  // Performs the mathematical calculation of the formula
  public calculate() {
    const numberQuestions =
      this.nodeSettings?.actionCardModel
        ?.getSearchService()
        .toArray(node => node instanceof BaseNumberQuestionNode)
        .filter(node => node.getCode()) || []
    const result = calculate(
      this.data.formula || '',
      Object.fromEntries(numberQuestions.map(node => [node.getCode(), Number(node.getValue()) || 0])),
    )

    return result
  }
}
